module.exports = __webpack_public_path__ + "static/integrations-placeholder-50d337fdf85c58f7b50e55081eb07fc3.png";